module.exports = __webpack_public_path__ + "img/header-img1.a296bd1c.png";